import { render, staticRenderFns } from "./boardLeft.vue?vue&type=template&id=6550a9ce&scoped=true&"
import script from "./boardLeft.vue?vue&type=script&lang=js&"
export * from "./boardLeft.vue?vue&type=script&lang=js&"
import style0 from "./boardLeft.vue?vue&type=style&index=0&id=6550a9ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550a9ce",
  null
  
)

export default component.exports